import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgGridModule} from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { AuthGuardService } from '../services/auth-guard.service';
import { TooltipModule } from 'primeng/tooltip';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MonthlyIncomeReportComponent } from './monthly-income-report.component';
import { TableModule } from 'primeng/table';
import { PoInvoiceDiscrepancyReportItem } from './po-discrepancy-report-item';
import { PoInvoiceDiscrepancyReportComponent } from './po-invoice-discrepancy-report.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AgGridModule,

    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    DividerModule,
    DropdownModule,
    TableModule,
    ToastModule,
    ToolbarModule,
    TooltipModule,
        
    RouterModule.forChild([
      {path: 'monthly-income-report', component: MonthlyIncomeReportComponent, canActivate: [AuthGuardService] },
      {path: 'po-invoice-discrepancy-report', component: PoInvoiceDiscrepancyReportComponent, canActivate: [AuthGuardService] }
    ])
  ],
  declarations:[
    MonthlyIncomeReportComponent,
    PoInvoiceDiscrepancyReportComponent
  ]
})
export class ReportModule{
}